<template>
  <div v-if="show" class="summary-panel">
    <h3>Biochar Applications Summary</h3>
    <div class="filter-info">
      <p v-if="startDate && endDate">
        <strong>Date Range:</strong> {{ formatDate(startDate) }} to {{ formatDate(endDate) }}
      </p>
      <p v-if="selectedLga">
        <strong>LGA:</strong> {{ selectedLga }}
      </p>
      <p v-if="!startDate && !endDate && !selectedLga">
        <em>No filters applied - showing all Biochar Applications</em>
      </p>
      <p>
        <em>Note: Experimental applications not included here</em>
      </p>
    </div>
    
    <button @click="$emit('close')" class="close-btn">X</button>
    
    <div class="summary-stats">
      <div class="stat-item">
        <span class="stat-label">Total Biochar Applied:</span>
        <span class="stat-value">{{ totalBiochar }} tons</span>
      </div>
      <div class="stat-item">
        <span class="stat-label">Net CO₂ Removal:</span>
        <span class="stat-value">{{ co2Removal }} tCO₂e</span>
      </div>
      <div class="stat-item">
        <span class="stat-label">Number of Biochar Applications:</span>
        <span class="stat-value">{{ applicationCount }}</span>
      </div>
    </div>
  </div>
</template>
  
<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
    totalBiochar: {
      type: Number,
      default: 0,
    },
    co2Removal: {
      type: Number,
      default: 0,
    },
    applicationCount: {
      type: Number,
      default: 0,
    },
    startDate: {
      type: [String, Date],
      default: null,
    },
    endDate: {
      type: [String, Date],
      default: null,
    },
    selectedLga: {
      type: String,
      default: null,
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      return d.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },
  },
};
</script>
    
<style scoped>
.summary-panel {
  position: absolute;
  bottom: 100px;
  left: 70px;
  background: white;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  max-width: 400px;
  z-index: 1000;
  font-family: Arial, sans-serif;
}

.summary-panel h3{
  margin-bottom: 0.5rem;
}

.filter-info {
  background: #f5f5f5;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 15px;
  border-left: 4px solid #4caf50;
}

.filter-info p {
  margin: 5px 0;
  font-size: 14px;
}

.filter-info em {
  color: #666;
}

.loading {
  text-align: center;
  padding: 20px;
  color: #666;
}

.error {
  color: #f44336;
  margin: 10px 0;
  padding: 10px;
  background: #ffebee;
  border-radius: 4px;
  border-left: 4px solid #f44336;
}

.summary-stats {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.stat-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #eee;
}

.stat-item:last-child {
  border-bottom: none;
}

.stat-label {
  font-weight: 500;
  color: #333;
}

.stat-value {
  font-weight: bold;
  color: #4caf50;
  margin-left: 0.3rem;
}

.close-btn {
  position: absolute;
  top: 0px;
  right: 0px;
  margin: 0;
  padding: 5px 10px;
  color: #000;
  border: none;
  cursor: pointer;
  font-size: 12px;
  font-weight: bolder;
}

.close-btn:hover {
  font-size: 14px;
}

button:not(.close-btn) {
  margin-top: 15px;
  padding: 8px 15px;
  background: #4caf50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  width: 100%;
}

button:not(.close-btn):hover {
  background: #3e8e41;
}
</style>